import { Alert, Snackbar, SnackbarProps } from '@mui/material'

type IProps = {
  message: string
  handleClose: () => void
} & SnackbarProps

const TranspotsErrorSnackbar = ({ message, open, handleClose }: IProps) => {
  return (
    <Snackbar open={open} onClose={handleClose} autoHideDuration={4000}>
      <Alert severity="error" variant="filled" sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  )
}

export default TranspotsErrorSnackbar
